import $ from 'jquery';
import Cookies from 'js-cookie';

class WCookies {
    constructor(element) {
        this._div = element;
        this._acceptCookieName = "acceptCookies";
        this._navigationCookieName = "navigationUrl";
        this.bindEvents();
        this.init();
    }
    bindEvents() {
        var _thisWCookies = this;
        $(this._div).on("click", '[data-id="accept-cookies"]', function () {
            _thisWCookies.acceptCookies();
        });
    }
    acceptCookies() {
        Cookies.set(this._acceptCookieName, 1, { expires: 1 });
        $(this._div).fadeOut();
        $(this._div).remove();
    }
    init() {
        if (parseInt(Cookies.get(this._acceptCookieName)) === 1) {
            $(this._div).remove();
        } else {
            $(this._div).css('display','flex');
            var _navigationUrl = decodeURIComponent(Cookies.get(this._navigationCookieName));
            if (_navigationUrl === "undefined") {
                Cookies.set(this._navigationCookieName, window.location.href, { expires: 1 });
            }
        }
    }
}

export default WCookies;
